import { GET_FOUND, GET_FOUND_SUCCESS, HIDE_FOUND_MESSAGE, ON_ADD_FOUND, ON_ADD_FOUND_SUCCESS, ON_HIDE_FOUND_LOADER, ON_SHOW_FOUND_LOADER, SHOW_FOUND_MESSAGE } from "../../constants/ActionTypes";

const INIT_STATE = {
  loader: false,
  alertMessage: "",
  showMessage: false,
  founds: null,
  foundId: null
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case ON_ADD_FOUND_SUCCESS: {
      return {
        ...state,
        loader: false,
      }
    }
    case ON_ADD_FOUND: {
      return {
        ...state,
        loader: true
      }
    }
    case SHOW_FOUND_MESSAGE: {
      return {
        ...state,
        alertMessage: action.payload,
        showMessage: true,
        loader: false
      }
    }
    case HIDE_FOUND_MESSAGE: {
      return {
        ...state,
        alertMessage: '',
        showMessage: false,
        loader: false
      }
    }


    case ON_HIDE_FOUND_LOADER: {
      return {
        ...state,
        loader: false
      }
    }

    case GET_FOUND: {
      return {
        ...state,
        loader: true
      };
    }

    case GET_FOUND_SUCCESS: {
      return {
        ...state,
        loader: false,
        founds: action.payload,
      };
    }


    case ON_SHOW_FOUND_LOADER: {
      return {
        ...state,
        loader: true,
      };
    }
    default:
      return state;
  }
};
